import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { Report } from 'app/shared/models/report';
import { AuthService } from 'app/shared/services/auth.service';
import { ReferralReportService } from 'app/shared/services/reporting/referral-report.service';
import { BaseComponent } from '../../base/base.component';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'reports',
  template: `<app-datagrid
              id="referralReportsGrid"
              #appList
              [title]="title"
              [rows]="data$|async"
              [columns]="columns"
              [keyProperty]="'uid'"
              [allowAdd]="false"
              [allowEdit]="true"
              (onDelete)="delete($event)"
              (onEdit)="edit($event)"
              fxFill>
            </app-datagrid>`,
  animations: fuseAnimations,
})
export class ReferralReportsComponent extends BaseComponent implements OnInit {

  data$: Observable<Report[]>;
  columns = [];
  title = 'Referral Reports';
  admin = false;

  constructor(private reportService: ReferralReportService, private authService: AuthService, private router: Router) {
    super();
    this.admin = this.authService.hasPriv('admin');
    this.data$ = this.reportService.onChanged.pipe(map((data) => {
      data.map((i) => {
        // if created by name not set then assume it is a System generated report and set the name accordingly
        if (!i.createdByName) {
          i.createdByName = 'System';
        }
        i.canDelete = i.canDelete && this.admin;
        return i;
      });
      return [...data];
    }));
  }

  ngOnInit() {
    this.columns = [{ name: 'Name', prop: 'name' }, { name: 'Description', prop: 'description' }, { name: 'Last Modified By', prop: 'createdByName' }];
  }

  edit(row) {
    this.router.navigateByUrl('/referralreports/' + row.uid);
  }

  delete(row) {
    // by this stage user has already confirmed the delete, so remove item from data source
    this.reportService.delete(row).subscribe();
  }
}
